import { ChangeDetectionStrategy, Component } from '@angular/core';
import { type PopoverDirective, PopoverModule } from 'ngx-bootstrap/popover';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-upgrade-plan-popover',
    templateUrl: './upgrade-plan-popover.component.html',
    styleUrls: ['./upgrade-plan-popover.component.less'],
    imports: [PopoverModule, TranslateModule],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradePlanPopoverComponent {
    public popover?: PopoverDirective;
    private hideTimeoutId: any = null;
    public isOpen: boolean = false;

    public onTriggerEnter(): void {
        this.clearHideTimeout();
        this.isOpen = true;
        this.popover?.show();
    }

    public onTriggerLeave(): void {
        this.hideWithDelay();
    }

    public onPopoverEnter(): void {
        this.clearHideTimeout();
    }

    public onPopoverLeave(): void {
        this.hideWithDelay();
    }

    public onHidden(): void {
        this.isOpen = false;
    }

    private hideWithDelay(delay = 150): void {
        this.clearHideTimeout();
        this.hideTimeoutId = setTimeout(() => {
            this.popover?.hide();
            this.isOpen = false;
            this.hideTimeoutId = null;
        }, delay);
    }

    private clearHideTimeout(): void {
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
            this.hideTimeoutId = null;
        }
    }
}
